const { mapLocale } = require('./mapping')
module.exports = {
  getPathname: (node_locale, slug) =>
    `/${mapLocale[node_locale]}${slug && slug !== '/' ? `/${slug}` : '/'}`
}